import { Grid, Typography } from "@mui/material";

const ContactHero = () => (
  <Grid
    container
    size={{ xs: 12, md: 6 }}
    justifyContent="center"
    alignItems="center"
    textAlign="center"
    flexDirection="column"
  >
    <Typography variant="h2" fontWeight="bold">
      CONTACT US
    </Typography>
    <Typography mt={3} variant="p">
      We’re here to help. <br />
      Get in touch with any questions or comments!
    </Typography>
  </Grid>
);

export default ContactHero;
